import { ComponentPropsWithRef } from "react";
import { ButtonProps as antdButtonProps, Button } from "antd";
import { SizeKeys } from "../../types/sizing";

export enum ButtonTypes {
    primary = "primary",
    hyperlink = "link",
    tertiary = "text",
    secondary = "default",
    tonal = "tonal",
}

export enum IconPosition {
    start = "start",
    end = "end",
}

type TypeKeys = keyof typeof ButtonTypes;
export interface ButtonProps
    extends Omit<antdButtonProps, "type" | "size" | "icon"> {
    // Add any additional props
    type?: TypeKeys;
    error?: boolean;
    size?: Exclude<SizeKeys, "small">;
    icon?: React.ReactNode;
    iconPosition?: keyof typeof IconPosition;
    loading?: boolean;
}

export type ButtonRef = ComponentPropsWithRef<typeof Button>["ref"];
